module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_04-1bb6d78a85f9b617172347e37e5f399b.png";